import { ResourceService } from '@watcherr/resources';
import TokenService from '~services/TokenService';

export function setResources() {
  ResourceService.init(TokenService);
}
